import { createFileRoute } from "@tanstack/react-router";

import ComingSoonCover from "@/components/ComingSoonCover";

import placeholder from "./-assets/placeholder-operation-activity.png";

export const Route = createFileRoute(
  "/_staff/id-managements/_layout/_placeholders/operation-activity",
)({
  component: () => <ComingSoonCover placeholderImage={placeholder} />,
});
